import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { useState } from 'react';
import './SynchrotronTrips.scss';
import { openNode } from 'utils/Global';

export type SynchrotronTripsProps = {
  id: number;
  title: string;
  collectionDate: Date;
};
export default function SynchrotronTripsRow(props: SynchrotronTripsProps) {
  const route = `/synchrotrontrip/${props.id}`;
  const [openedWindows, setOpenedWindows] = useState([]);

  const onClickNode = () => {
    openNode(route, route, props.id, openedWindows, setOpenedWindows);
  };

  return (
    <div id='synchrotrontripsrow-recent-opened-container' className="recentOpenedDetailRow bg-white" onDoubleClick={onClickNode}>
      <RMSvgIcon
        id='synchrotrontripsrow-svg-icon'
        name={
          new Date(props.collectionDate).setHours(0, 0, 0, 0) >=
          new Date().setHours(0, 0, 0, 0)
            ? 'SynchrotronTripv4_Open'
            : 'SynchrotronTripv4_Close'
        }
        noFill={true}
        style={{ marginRight: 15 }}
        width="30"
        height="30"
      />
      <div id='synchrotrontripsrow-icon-text' className=" flex flex-col w-[90%] h-[100%] overflow-auto justify-center">
        <div id={`synchrotrontripsrow-title-${props.title}`} className="synchrotronTitle">{props.title}</div>
        <div id={`synchrotrontripsrow-subtitle-${props.collectionDate.toDateString()}`} className="synchrotronSubTitle">{props.collectionDate.toDateString()}</div>
      </div>
    </div>
  );
}
